import { TableRow, withStyles } from "@material-ui/core";

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#f5f5f5',
        },
    },
}))(TableRow);
export default StyledTableRow;